import script from "./invoices-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./invoices-modal.vue?vue&type=script&setup=true&lang=js"

import "./invoices-modal.vue?vue&type=style&index=0&id=7a8b25cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8b25cc"]])

export default __exports__